module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.isRounded),
      callback: function($$v) {
        _vm.isRounded = $$v
      },
      expression: "isRounded"
    }
  }, [_vm._v("Rounded")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.isOutlined),
      callback: function($$v) {
        _vm.isOutlined = $$v
      },
      expression: "isOutlined"
    }
  }, [_vm._v("Outlined")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("Danger")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1)], 1), _vm._v(" "), _c('b-switch', {
    attrs: {
      "rounded": _vm.isRounded,
      "outlined": _vm.isOutlined,
      "size": _vm.size,
      "type": _vm.type
    }
  }, [_vm._v("Sample")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a3c8d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/switch/examples/ExStyles.vue
// module id = 1197
// module chunks = 28 93